import { CacheUpdateEvent } from '@/rec-cache/rec-cache-events'

// Contrary to the index selector this selector shall have a list with all ids that have a geo coordinate.
// Implement in Selector class
class GeoCoordSelection {
  constructor(geoCoords, refreshFn) {
    this._selection = [...geoCoords.keys()]
    this.geoCoords = geoCoords
    this.refreshFn = refreshFn

    console.log(
      'rec-cache.rec-cache-geo-coord-selection.geo-cord-selection.constructor',
      this._selection
    )

    if (refreshFn) refreshFn(this._selection)
  }
  // TODO consider if a set rather than array shall be returned.
  get selection() {
    return this._selection
  }

  clear() {
    this._selection = []
    if (this.refreshFn) this.refreshFn(this._selection)
  }

  // TODO consider if the geo coordinates shall be queryable, eg within a bounding box or polygon. For now all are selected.
  query() {
    this._selection = [...this.geoCoords.keys()]
    if (this.refreshFn) this.refreshFn(this._selection)
    return this._selection
  }

  update(id /*, geoCoord */) {
    if (!this._selection.includes(id)) {
      this._selection.push(id)
      if (this.refreshFn) this.refreshFn(this._selection)
    }
  }

  add(id /* geoCoord */) {
    // TODO currently, with no query, all geo coords are inserted into selection.
    this._selection.push(id)
    if (this.refreshFn) this.refreshFn(this._selection)
  }
}

class GeoCoordSelector {
  constructor(geoCoordParserFn) {
    console.log(
      'rec-cache.rec-cache-geo-coord-selector.geo-cord-selector.constructor'
    )
    this._states = []
    this.geoCoords = new Map()
    this.parsedIds = new Set()
    this.geoCoordParserFn = geoCoordParserFn

    // TODO use different events for create, update and delete. Removes need for parsedIds set.
    addEventListener(CacheUpdateEvent, this.update.bind(this))
  }

  clear() {
    this.geoCoords.clear()
    this.parsedIds.clear()

    this._states.forEach((s) => s.clear())
  }

  update({ detail: individual }) {
    // console.log(
    //   'rec-cache.rec-cache-geo-coord-selector.geo-cord-selector.update',
    //   individual
    // )

    const id = individual.id.value
    const isUpdate = this.parsedIds.has(id)
    if (isUpdate) {
      // TODO remenber to check for delete... how should delete be communicated?
      // TODO implement at a later stage.
    }

    // Check for viable geo coordinates.
    // TODO support multiple geo coords per individual.
    // TODO implement use of meta data property for geo coords.
    const geoCoord = this.geoCoordParserFn(individual)
    if (!!geoCoord && geoCoord.isDefined) {
      this.geoCoords.set(id, [geoCoord])
      this._states.forEach((s) =>
        isUpdate ? s.update(id, geoCoord) : s.add(id, geoCoord)
      )
    }

    this.parsedIds.add(id)
  }

  createSelection(refreshFn = null) {
    const selection = new GeoCoordSelection(this.geoCoords, refreshFn)
    this._states.push(selection)
    return selection
  }
}

export { GeoCoordSelector }
